module.exports = __webpack_public_path__ + "images/bannerPT-81a0162c87c0fc96015a3150c052eb72.png";